import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import styled from 'styled-components';
import { HHInput, HHCheckbox, HHFileUploader, HHSingleSelect } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    question: Yup
      .string().min(1, translate('form.error.string.min')).max(200, translate('form.error.string.max'))
      .required(translate('form.error.mixed.required')),
    required: Yup.boolean(),
    questionType: Yup.string().required(translate('form.error.mixed.required')),
    file: Yup.string()
  }),
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.LOGIN_FORM
});

const ApplicationQuestionForm = (props) => {
  const {
    handleCancel,
    handleSubmit,
    isSubmitting,
    isEditing,
    translate,
    values,
    eventSlug,
    user
  } = props;

  const typeOptions = [
    {
      label: translate('application.commonFields.string'),
      value: 'String'
    },
    {
      label: translate('application.commonFields.textArea'),
      value: 'TextArea'
    },
    {
      label: translate('application.commonFields.number'),
      value: 'Number'
    },
    {
      label: translate('application.commonFields.boolean'),
      value: 'Boolean'
    },
    {
      label: translate('application.commonFields.file'),
      value: 'File'
    }
  ];

  return (
    <Form
      onSubmit={handleSubmit}
      className='cms-judgingCriteria_form cms-judgingCriteria_table_item_description'
    >
      <div className='cms-judgingCriteria_form_formGroup'>
        <Form.Field>
          <label htmlFor='question'>{translate('question.required')}</label>
          <Field
            name='question'
            component={HHInput}
            otherProps={{
              type: 'text',
              id: 'question'
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-judgingCriteria_form_limit'>
        <Form.Field>
          <label htmlFor='questionType'>{translate('application.questionType')}</label>
          <Field
            name='questionType'
            component={HHSingleSelect}
            otherProps={{
              id: 'questionType',
              simpleValue: true,
              searchable: false,
              clearable: false,
              // defaultValue: 'String',
              options: typeOptions
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-awards_form_btnGroup'>
        <Form.Field>
          <label htmlFor='question'>{translate('application.required')}</label>
          <Field
            name='required'
            component={HHCheckbox}
            otherProps={{
              type: 'checkbox',
              toggle: true
            }}
          />
        </Form.Field>
      </div>
      <div className='cms-judgingCriteria_form_formGroup'>
        <Form.Field>
          <label>
            {translate('Upload Your File')} (word, pdf or ppt file)
          </label>
          <Field
            name='file'
            component={HHFileUploader}
            otherProps={{
              type: 'compression + document',
              fileType: 'screening_application_form_upload',
              slug: eventSlug,
              userToken: user.token,
              trigger: (
                <Button type='button' basic color='blue'>
                  <i className='fal fa-arrow-from-bottom fa-mr' />
                  {translate('upload.file')}
                </Button>
              )
            }}
          />
          {((!values.fileTempUrl && values.file) || values.fileTempUrl) && (
            <Button
              type='a'
              href={!values.fileTempUrl && values.file ? values.file : values.fileTempUrl && values.fileTempUrl}
              basic
              color='blue'
              target='_blank'
            >
              <i className='fal fa-arrow-to-bottom fa-mr' />
              {translate('Download')}
            </Button>
          )}
        </Form.Field>
      </div>
      <div />
      <StyledDiv>
        {handleCancel && (
          <Button
            basic
            type='button'
            onClick={handleCancel}
            className='cms-awards_form_btnGroup_btn-cancel'
          >
            {translate('cancel')}
          </Button>
        )}
        <Button
          loading={isSubmitting}
          primary
          disabled={isSubmitting}
          className='cms-awards_form_btnGroup_btn-submit'
          type='submit'
        >
          {isEditing ? translate('save') : translate('create')}
        </Button>
      </StyledDiv>
    </Form>
  );
};

const StyledDiv = styled.div`
  justify-self: flex-end
`;

export default compose(
  withLocalize,
  formikEnhancer
)(ApplicationQuestionForm);



// WEBPACK FOOTER //
// ./src/components/forms/applicationQuestionForm.js